import {getCurrentInstance} from 'vue';
import type {LogMethods} from '@significo/pulse';
import {loggerInstance} from '@/ts/instances/logger-instance';

/** Returns a logger instance scoped to the current Vue component name, with an optional suffix */
export function useLogger(id?: string): LogMethods {
  const instance = getCurrentInstance();
  // eslint-disable-next-line no-underscore-dangle
  let logName = instance?.type.__name ?? 'vue-comp';
  if (id) {
    logName += `-${id}`;
  }
  return loggerInstance.getLogger(logName);
}
